import React from 'react';
import Typography from '@material-ui/core/Typography';
import T from 'i18n-react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  first: {
    marginBottom: theme.spacing(1.5),
  },
  second: {
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(1.5),
  },
}));

const NearbyDescription = () => {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.first} color="textSecondary">
        {T.translate('plans.nearby.desc1')}
      </Typography>
      <Typography className={classes.second} color="textSecondary">
        {T.translate('plans.nearby.desc2')}
      </Typography>
    </>
  );
};

export default NearbyDescription;
